import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_86: DocMigration = {
  maxSchemaVersion: "0.0.86",
  description: "Migrate wainscoting and framing wall config to settings",
  apply(json: any) {
    const allSettings = json.settings;
    const blocks = json.blocks;

    // wainscoting config
    if (json.wainscotingConfig) {
      // build the new fields
      const { leftThreshold, rightThreshold, lateralThreshold, suppressOnBlocks = [] } = json.wainscotingConfig;

      const newWainscotingSettings = {
        leftThreshold,
        rightThreshold,
        lateralThreshold,
      };

      // add them to the existing wainscoting settings
      for (const settingId in json?.settings) {
        const setting = json.settings[settingId];
        if (setting?.type === "WAINSCOTING_SETTINGS") {
          json.settings[settingId] = {
            ...json.settings[settingId],
            ...newWainscotingSettings,
          };
        }
      }

      if (!json.settingsOverride) {
        json.settingsOverride = {};
      }

      if (!json.settingsOverride.wainscoting) {
        const wainscotingSettingsId = uid();
        allSettings[wainscotingSettingsId] = {
          type: "WAINSCOTING_SETTINGS",
          ...newWainscotingSettings,
        };

        json.settingsOverride.wainscoting = wainscotingSettingsId;
      }

      // add the suppress wainscoting flag to the required blocks
      for (const blockId of suppressOnBlocks) {
        const block = blocks[blockId];
        if (block) {
          block.suppressWainscoting = true;
        }
      }

      // delete the old config
      delete json.wainscotingConfig;
    }

    // wall framing config
    if (json.wallFramingConfig) {
      // create the new wall framing setting
      const { hasDoubleKingStuds, hasDoubleHeader, hasJackStuds, hasCrippleStudEnds, roughOpeningBorder } =
        json.wallFramingConfig;

      const wallFramingSettingsId = uid();
      allSettings[wallFramingSettingsId] = {
        type: "WALL_FRAMING_SETTINGS",
        hasDoubleKingStuds,
        hasDoubleHeader,
        hasJackStuds,
        hasCrippleStudEnds,
        roughOpeningBorder,
      };

      if (!json.settingsOverride) {
        json.settingsOverride = {};
      }

      json.settingsOverride.wallFraming = wallFramingSettingsId;

      // delete the old config
      delete json.wallFramingConfig;
    }

    return json;
  },
};

export default migration_0_0_86;
